import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function KnowledgeDialog(props) {
   
  const {openVideo, setOpenVedio} = props;
  
  const handleClose = () => {
    setOpenVedio({
        ...openVideo, open:false, path:'', name:''
      });
  };

  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openVideo?.open} maxWidth="sm" fullWidth="sm">
        {/* <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {openVideo?.name}
        </DialogTitle> */}
          <DialogContent dividers>
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 py-0 center">
                <video style={{width:'inherit'}} controls >
                    <source src={`${axios.defaults.baseURL}tutorial/${openVideo?.path}`} type={openVideo?.video_type}/>
                </video>
              </div>
            </div>
          </DialogContent>
          {/* <DialogActions>
            <Button color="primary" variant="contained" className="pull-right">
              Close
            </Button>
          </DialogActions> */}
      </Dialog>
    </div>
  );
}
